'use strict';

const geScriptsBase = require('./../../../../../../../richemont/cartridges/int_globale_custom/cartridge/client/default/js/geScriptLoader');
const { isEmpty, get, debounce } = require('lodash');
const { GeScriptLoader, Helpers } = geScriptsBase;

Helpers.injectDatalayer = async (url, body) => {
    const response = await Helpers.makeJsonAjaxCall(url, 'POST', body);

    let analyticsResponse = {};
    try {
        analyticsResponse = JSON.parse(response);
    } catch (error) {
        analyticsResponse = {};
    }

    const datalayer = get(analyticsResponse, 'datalayer', []);
    if (!isEmpty(datalayer)) {
        datalayer.forEach((layer) => {
            window.dataLayer.push(layer);
        });
    }
};

GeScriptLoader.prototype.onCheckoutStepLoadedHandler = async function (data) {
    try {
        if (data.StepId === data.Steps.CONFIRMATION) {
            // stop sending keepAlive ajax call
            if ('globaleKeepAlive' in window && window.globaleKeepAlive) {
                clearInterval(window.globaleKeepAlive);
            }
        }
        const geIframe = document.querySelector('#gle_iframe');
        await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
    } catch (e) {
        console.error(e); // eslint-disable-line no-console
    }
};

/**
 * Handler function of 'GlobalE.OnClientEvent' event
 * Used for Extreme Analytic
 * @param {string} source - Event source
 * @param {Object} data - Event data
 */
GeScriptLoader.prototype.onClientEvent = (function () {
    const DEBOUNCE_DELAY = 100; // ms
    const debouncedHandlers = {};

    /**
     * Handles client events from GE payment iframe and sends analytics data.
     * Enriches event data with currency/country info and routes to analytics layer.
     *
     * @async
     * @param {string} source - Event type from GEMerchantUtils.ClientEvents
     * @param {Object} data - Event data object
     * @param {string} [data.action] - Action type for BUTTON_CLICKED events
     * @returns {Promise<void>} void
     */
    async function handleEvent(source, data) {
        const geIframe = document.querySelector('#gle_iframe');
        data.GECustomerCurrencyCode = geScriptLoaderData.currency; // eslint-disable-line no-undef
        data.GEShippingMethod = geScriptLoaderData.country; // eslint-disable-line no-undef
        data.source = source;
        switch (source) {
            case GEMerchantUtils.ClientEvents.PAYMENTMETHOD_CHANGED: // eslint-disable-line no-undef
                await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
                break;
            case GEMerchantUtils.ClientEvents.BILLING_ADDRESS_COMPLETED: // eslint-disable-line no-undef
                await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
                break;
            case GEMerchantUtils.ClientEvents.SHIPPINGMETHOD_SELECTION: // eslint-disable-line no-undef
                await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
                break;
            case GEMerchantUtils.ClientEvents.CHECKOUT_FAILURE: // eslint-disable-line no-undef
                await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
                break;
            case GEMerchantUtils.ClientEvents.BUTTON_CLICKED: // eslint-disable-line no-undef
                if (data.action === 'Pay') {
                    const isShippingMethodPushed = window.dataLayer
                        ? window.dataLayer.some((item) => item && typeof item === 'object' && 'event' in item && item.event === 'add_shipping_method')
                        : false;
                    data.isShippingMethodPushed = isShippingMethodPushed;
                    await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
                }
                break;
            default:
                break;
        }
    }

    return async function (source, data) {
        try {
            // Create a debounced handler for this source if it doesn't exist
            if (!debouncedHandlers[source]) {
                debouncedHandlers[source] = debounce(handleEvent, DEBOUNCE_DELAY);
            }

            // Call the debounced handler
            debouncedHandlers[source](source, data);
        } catch (e) {
            console.error(e.message); // eslint-disable-line no-console
        }
    };
})();
